import React from "react";
import { Button, Form, Modal, Row, Spinner } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import {
  AddDataToLargeClaim,
  GetClientLargeClaimyClientName,
  ImportLargeClaim,
} from "../../../../api/User/ACG/ClientLargeClaimApi";
import { useSelector } from "react-redux";
import { DownloadCensusErrorFile } from "../../../../api/User/ACG/ImportCensusApi";

const schema = Yup.object().shape({
  client_ID: Yup.string().required("required"),
  client_Name: Yup.string().required("required"),
  carrier: Yup.string().required("required"),
  relationship: Yup.string().required("required"),
  plan_Type: Yup.string().required("required"),
  ICD10_X: Yup.string().required("required"),
  medc_RXMG_Type: Yup.string().required("required"),
  initial_DOS: Yup.string().required("required"),
  maturity_Months: Yup.string().required("required"),
  eru: Yup.string().required("required"),
  paid: Yup.string().required("required"),
  risk_Score: Yup.string().required("required"),
  zip: Yup.string().required("required"),
});

const ClientLargeClaim = () => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);
  const [importedFile, setImportedFile] = useState(null);
  const [message, setMessage] = useState({
    isModal: false,
    file: "",
    success: undefined,
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [importConformationModal, setImportConformationModal] = useState(false);
  const fileInputRef = useRef(null);

  const overrideColumn = [
    { title: "Client ID", field: "client_ID" },
    { title: "Client Name", field: "client_Name" },
    { title: "Carrier", field: "carrier" },
    { title: "Relationship", field: "patient_Relationship" },
    { title: "Plan Type", field: "plan_Type" },
    { title: "ICD10/RX", field: "icD10_Code" },
    { title: "ICD10/RX Description", field: "icD10_Description" },
    { title: "MEDC/ RXMG Type", field: "medC_TYPE" },
    { title: "Claim Period Start Date", field: "initialDOS" },
    // { title: "Maturity Months", field: "maturity_Months" },
    // { title: "ERU", field: "eru" },
    { title: "Paid($)", field: "totalPaid" },
    { title: "Concurrent Estimated Risk Score", field: "risk_Score" },
    { title: "Zip", field: "zip" },
  ];

  useEffect(() => {
    getData();
  }, [client]);

  useEffect(() => {
    const importedFileName = importedFile?.name;
    const importedFileFormat = importedFileName?.substring(
      importedFileName.lastIndexOf(".") + 1
    );

    if (importedFile) {
      setIsSpinner(true);
      if (importedFileFormat !== "csv") {
        toastFile("invalid file");
        setImportedFile(null);
        setIsSpinner(false);
        return;
      }

      const formData = new FormData();
      formData.append("files", importedFile);
      let client_name = client?.clientName.replaceAll("&", "%26").replaceAll("#", "%23");
      ImportLargeClaim(
        client?.clientID,
        client_name,
        user?.UD_id,
        user?.UD_emp_name,
        formData,
        user?.UD_id
      )
        .then((res) => {
          setIsSpinner(false);
          if (res.status === 200) {
            if (res.data.success) {
              if (res.data.message === "failed") {
                setMessage((prev) => ({
                  isModal:true,
                  file: res.data.file,
                  success: true,
                }));
              }
              setImportConformationModal(true);
            } else {
              switch (res.data.message) {
                case "Client Name Not Match":
                  toastFile(res.data.message);
                  break;
                case "Company is not setup in login user":
                  toastFile(
                    "Please fill details in company setup and Try again"
                  );
                  break;
                case "failed":
                  setMessage((prev) => ({
                    isModal: true,
                    file: res.data.file,
                    success: false,
                  }));
                  break;
                default:
                  toastFile("File Not Uploaded");
                  break;
              }
            }
            setImportedFile(null);
          }
        })
        .catch((err) => {
          setIsSpinner(false);
          console.log({ err });
        });
    }
  }, [importedFile]);

  const getData = () => {
    setIsLoading(true);
    GetClientLargeClaimyClientName(client?.clientID)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  return (
    <div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Have you prepared the import file using the CSV template?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              fileInputRef.current.click();
              setShowModal(false);
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setShowModal(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={importConformationModal}
        onHide={() => setImportConformationModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Would you like to override the existing large claim(s)?
          <div className="mt-3">Yes = Replaces all large claims.</div>
          <div>No = Adds new claims to the existing record(s).</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
              setImportConformationModal(false);
              setIsSpinner(true);
              AddDataToLargeClaim(
                client?.clientID,
                user?.UD_emp_name,
                true,
                user.UD_id
              ).then((res) => {
                setIsSpinner(false);
                if (res.status === 200) {
                  if (res.data === "failed") {
                    toastFile("File Not Uploaded")
                    // setMessage((prev) => ({ ...prev, isModal: true }));
                  } else {
                    toastFile("imported");
                  }
                  getData();
                }
              });
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setImportConformationModal(false);
              setIsSpinner(true);
              AddDataToLargeClaim(
                client?.clientID,
                user?.UD_emp_name,
                false,
                user.UD_id
              ).then((res) => {
                setIsSpinner(false);
                if (res.status === 200) {
                  if (res.data === "failed") {
                    // setMessage((prev) => ({ ...prev, isModal: true }));
                  } else {
                    toastFile("imported");
                  }
                  getData();
                }
              });
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={message.isModal && message.success}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          There are records that cannot be imported due to invalid ICD10
          code/Zip code. The records will be reviewed by an administrator, once
          reviewed you will be contacted with next steps.
          <div className="mt-3">
            * Records with correct ICD10 and Zip code will be imported.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ ...prev, isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal
        show={message.isModal && message.success === false}
        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          There are blank or invalid values in your import file. Please click
          Download Error Log, correct the import file accordingly, and try
          again.
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              className="bg-transparent border-0 text-primary"
              onClick={() => {
                DownloadCensusErrorFile(message.file).then((data) => {
                  const blob = new Blob([data.data], {
                    type: "text/plain",
                  });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = message.file;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  setMessage((prev) => ({ ...prev, isModal: false, file: "" }));
                });
              }}
            >
              Download Error Log
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {isSpinner && (
        <>
          {/* <div
          style={{
            marginTop:"-5%",
            width: "97%",
            height: "70vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            //border: "1px solid black",
            opacity: 0.2,
            backgroundColor:"black",
            position: "absolute",
            zIndex: 10,
          }}
        >
        </div> */}
          <div
            style={{
              marginTop: "-6%",
              width: "97%",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "transparent",
              position: "absolute",
              zIndex: 11,
            }}
          >
            <div
              style={{
                marginTop: "10%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Spinner
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="false"
              />
              <span>Please Wait</span>
            </div>
          </div>
        </>
      )}
      <div className="text-end py-3 border-bottom">
        <a
          className="me-3"
          href="/samplefile/Large_Claim_Import_Template.csv"
          target={"_blank"}
          style={{
            textDecoration: "none",
          }}
          onMouseOver={(e) => {
            e.target.style.textDecoration = "underline";
          }}
          onMouseOut={(e) => {
            e.target.style.textDecoration = "none";
          }}
          download
        >
          Download Import Template
        </a>

        <CustomButton
          onClick={() => {
            if (
              client === null ||
              client?.clientID === null ||
              client?.clientID === 0
            ) {
              toastFile("Select Client");
            } else {
              setShowModal(true);
            }
          }}
        >
          Import Claim
        </CustomButton>
        <input
          type="file"
          ref={fileInputRef}
          onChange={(event) => {
            setImportedFile(event.target.files[0]);
            event.target.value = "";
          }}
          style={{ display: "none" }}
        />
      </div>

      <CustomMaterialTable
        isExport={false}
        overrideColumn={overrideColumn}
        data={data}
        isLoading={isLoading}
        setSelectedRow={setSelectedRow}
      />
    </div>
  );
};

export default ClientLargeClaim;
